import React, { useState, useEffect } from 'react';
import { Terminal, Star } from 'lucide-react';
import { motion } from 'framer-motion';

function Header() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <motion.header 
      className={`fixed w-full z-50 transition-all duration-300 ${isScrolled ? 'bg-gray-800 shadow-lg' : 'bg-transparent'}`}
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <nav className="flex justify-between items-center px-4 py-4">
        <motion.div 
          className="flex items-center space-x-2"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          <Terminal className="w-8 h-8 text-blue-400" />
          <span className="text-2xl font-bold text-white">Fleem</span>
        </motion.div>
        <motion.a
          href="https://github.com/adityavijay21/fleem"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center space-x-2 text-white bg-gray-700 hover:bg-gray-600 px-4 py-2 rounded-full transition-colors duration-200"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          aria-label="Star Fleem on GitHub"
        >
          <Star className="w-5 h-5" />
          <span>Star Fleem</span>
        </motion.a>
      </nav>
    </motion.header>
  );
}

export default Header;